import type {PropsOf, ChakraComponent} from '@chakra-ui/system';
import {ChakraH3} from '@linx-security/ui/utils/chakra-elements';
import type {FC} from 'react';

import {useStepperStyleConfig} from '../../theme-config';

type Props = {} & PropsOf<typeof Title>;

const StepTitle: FC<Props> = (props: Props) => {
  const style = useStepperStyleConfig(`title`);
  return <Title {...style} {...props} />;
};

export default StepTitle;
export type {Props as StepTitleProps};

const Title: ChakraComponent<'h3', {}> = ChakraH3;
